document.addEventListener("DOMContentLoaded", ()=>{
    console.log('nosto.............................................')
    const nostoControlledElements = document.querySelectorAll(".nosto-controlled-section");
    // nostoControlledElements.forEach((element)=>{
    //     element.classList.add("opacity-50");
    // })

    const el = document.getElementById('nosto-controll-trigger');
    if (el) {
    const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
        if (m.type === 'childList' && m.addedNodes.length) {
            const goTrigger = m.addedNodes[0].querySelector(".go-go-go")
            if(goTrigger){
                sortNostoSections()
            }
        }
        }
    });
    observer.observe(el, { childList: true }); 
    }

    const sortNostoSections = () =>{
        setTimeout(()=>{
            console.log("sorting nosto sections")
            const nostoSegmentSelectorWrapper = document.getElementById("nosto-controlled-page-container")
            console.log(nostoSegmentSelectorWrapper)
            const nostoSegmentSelector = nostoSegmentSelectorWrapper?.querySelector(".nosto-controller");
            console.log(nostoSegmentSelector)
            const segment = nostoSegmentSelector?.dataset.segment || "other";
            nostoControlledElements.forEach((element)=>{
                console.log(element)
                const segmentToShow = element.dataset.segment;
                if(segment != segmentToShow){
                    element.classList.add("hidden")
                }
                if(segment == segmentToShow){
                    element.classList.remove("hidden")
                }
                const animatedEles = Array.from(element.querySelectorAll(".animate-mt"));
                        animatedEles.forEach((ele)=>{
                            ele.classList.remove("animate-mt");
                        })

            })
        },100)
    }
})